module.exports = __webpack_public_path__ + "static/media/icapb2b_large.ac42f151.png";